import React from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';

interface GlimmerAnimationProps {
  className?: string;
}

const GlimmerAnimation: React.FC<GlimmerAnimationProps> = ({ className }) => {
  return (
    <>
      <motion.div
        className={cn('absolute h-full w-full', className)}
        style={{
          background:
            'linear-gradient(120deg, transparent 40%, rgba(255, 255, 255, 0.7) 60%, rgba(255, 255, 255, 0.9) 100%)',
          clipPath: 'polygon(0% 0%, 100% 0%, 40% 100%, 0% 100%)',
        }}
        animate={{
          x: ['-120%', '120%'],
        }}
        transition={{
          repeat: Infinity,
          repeatType: 'loop',
          duration: 0.8,
          ease: 'easeInOut',
          repeatDelay: 1.7,
        }}
      />
      <motion.div
        className={cn('absolute h-full w-full', className)}
        style={{
          background:
            'linear-gradient(120deg, transparent 40%, rgba(255, 255, 255, 0.7) 60%, rgba(255, 255, 255, 0.9) 100%)',
          clipPath: 'polygon(0% 0%, 100% 0%, 40% 100%, 0% 100%)',
        }}
        animate={{
          x: ['-120%', '120%'],
        }}
        transition={{
          repeat: Infinity,
          repeatType: 'loop',
          duration: 1,
          ease: 'easeInOut',
          repeatDelay: 1.5,
        }}
      />
    </>
  );
};

export default GlimmerAnimation;
